import * as types from './types'
import * as UserState from './state'
import {STORAGE_KEY} from '../../state'
import moment from 'moment'

const clearState = (oldState, newState) => {
	if (oldState !== null && oldState !== undefined) {
		Object.keys(oldState).forEach((key) => {
			if (typeof oldState[key] === 'object') {
				if (oldState[key] instanceof Array) {
					oldState[key] = []
				} else if (typeof newState !== 'undefined') {
					oldState[key] = clearState(oldState[key], newState[key])
				}
			} else if (typeof newState !== 'undefined') {
				oldState[key] = newState[key]
			}
		})
	}
	return oldState
}

const roleComputer = (roles) => {
	if (roles.indexOf('ROLE_ANONYMOUS') !== -1) {
		return 'ANONYMOUS'
	} else if (roles.indexOf('ROLE_ADVISOR') !== -1) {
		return 'ADVISOR'
	} else {
		return 'CLIENT'
	}
}

export const mutations = {
	[types.LOGIN] (state, data) {
		state.token = data.token
		state.refresh = data.refresh_token
		state.id = data.user.id
		state.email = data.user.email
		state.role = roleComputer(data.user.roles)
		state.tutorialFinished = data.user.tutorial_finished
		state.isForceCompleteProfile = data.user.force_complete_profile

		state.token_duration = moment().add(process.env.USER_TOKEN_DURATION, 'seconds').format()
	},
	[types.TOKEN] (state, data) {
		state.token = data.user.token
		state.refresh = data.user.refresh_token

		state.token_duration = moment().add(process.env.USER_TOKEN_DURATION, 'seconds').format()
	},
	[types.LOGOUT] (state) {
		clearState(state, UserState.default)
		window.localStorage.removeItem(STORAGE_KEY)
	},
	[types.UPDATE_PROFILE]  (state, data) {
		state.firstname = data.firstname
		state.lastname = data.lastname
		state.address = {
			line: data.address.line,
			zip: data.address.zip,
			city: data.address.city,
			country: data.address.country
		}
		state.phone = data.phone
		state.isEstate = data.isEstate
		state.birthdate = data.birthdate.split('-').reverse().join('-')
	},
	[types.PROFIL_PICTURE] (state, data) {
		state.picture = data.image
	},
	[types.GET_ADVISORS] (state, data) {
		state.advisors = data || []
	},
	[types.GET_INVESTMENT_STATS] (state, data) {
		state.investment_stats = data || []
	},
	[types.FILL_ESTATE] (state) {
		state.isEstate = true
	},
	[types.TUTORIAL_FINISHED] (state) {
		state.tutorialFinished = true
	},
	[types.FORCE_COMPLETE_PROFILE] (state) {
		state.isForceCompleteProfile = true
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/mutations.js